import Snappy from "../../../libs/snappy/snappy";
import $ from 'jquery';

Snappy.Component.EduCourseLoader = class EduCourseLoader extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-course-loader';
    }

    constructor(element) {
        super(element);
        this.element = element;
        this.containerForTable = document.getElementById('availability');
        this.pageID = this.element.dataset.pageId;
        this.firstPartUrl = window.location.host + '/educationhub/eduhubcourses/courseavailability?countyFAId=';

        this.addListeners = this.addListeners.bind(this);
        this.render = this.render.bind(this);
        this.get = this.get.bind(this);
        this.setOnLoad = this.setOnLoad.bind(this);
        this.replaceTable = this.replaceTable.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    render () {
        this.addListeners();

        if (this.element.value) {
            this.getAvailability();
        }
    }

    addListeners() {
        this.element.addEventListener('change', this.onChange);
    }

    getAvailability() {
        this.containerForTable.style.minHeight = 200 + 'px';
        const value = this.element.value;
        const selectedText = this.element.options[this.element.selectedIndex].innerText;
        if ((value.length > 0) && (this.pageID)) {
            this.containerForTable.classList.add('cfa-preloader--active');
            this.get(value);
            $(window).trigger('gtm:send', [ this.$element.data('gtm-category'), this.$element.data('gtm-action'), `${selectedText} > ${this.$element.data('title')}`]);
        }
    }

    onChange() {
        this.getAvailability();
    }

    get(value) {
        this.url = 'http://' + this.firstPartUrl + value + '&pageId=' + this.pageID;

        this.request = new XMLHttpRequest();
        this.request.onloadend = this.setOnLoad;
        this.request.open('GET', this.url);
        this.request.send();
    }

    setOnLoad() {
        if ((this.request.readyState === 4) && (this.request.status === 200)) {
            this.replaceTable(this.request.response);
        } else {
            console.log('Error on ' + this.url +'  \nHTTP status:\n readyState = ' + this.request.readyState + '\n status = ' + this.request.status);
        }
    }

    replaceTable(response) {
        this.containerForTable.classList.remove('cfa-preloader--active');
        this.containerForTable.innerHTML = response;
        this.containerForTable.removeAttribute('style');
        $(window).trigger('content:updated');
    }
};



// WEBPACK FOOTER //
// ./components/edu-course-loader/scripts/edu-course-loader.js